module.exports = __webpack_public_path__ + "static/img/89.8242aaf8.jpg";